"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _queryString = _interopRequireDefault(require("query-string"));
var _Application = _interopRequireDefault(require("./Application.js"));
var _History = _interopRequireDefault(require("./History.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Navigator utility
 * Handles navigation between URIs.
 * 
 * Original author @heron-web/material (no longer maintained)
 */
class Navigator {
  /**
   * Navigate to a given URI and reset the scroll location.
   * 
   * Calls `Application.onNavigate()` with the new and current URIs.
   *
   * @param {String} uri
   * @return {void}
   */
  static navigate(uri) {
    const current = this.uri;
    if (!uri.startsWith("/")) {
      uri = `/${uri}`;
    }
    if (uri !== current) {
      _History.default.push(uri);
    }
    _Application.default.onNavigate?.(uri, current);
    window.scrollTo({
      top: 0,
      left: 0
    });
  }

  /**
   * Update the content of the query string using a given object.
   *
   * @param {Object} params
   * @return {void}
   */
  static updateQueryString(params) {
    const query = _queryString.default.parse(_History.default.location.search);
    Object.assign(query, params);
    let str = _queryString.default.stringify(query);
    if (str) str = `?${str}`;
    Navigator.navigate(`${_History.default.location.pathname}${str}`);
  }

  /**
   * Get the current URI with query string.
   *
   * @return {String}
   */
  static get uri() {
    return `${_History.default.location.pathname}${_History.default.location.search}`;
  }
}
var _default = exports.default = Navigator;